import type { ReactNode } from "react"
import { IconMsgOutline18 as MessageCircle } from "nucleo-ui-outline-18"

import {
	portalGroupCardClass,
	portalGroupHeaderClass,
	portalGroupHeaderStyle,
	portalGroupPanelClass,
} from "../../styles/portal-group-card"
import { PortalGroupCollapse } from "../portal-group-collapse"
import { PortalSectionHeader } from "../portal-section-header"

interface Props {
	children: ReactNode
	title: string
	statusType: string
	count?: number
	collapsible?: boolean
	collapsed?: boolean
	onToggle?: () => void
	// The portal's grouped card look; the dashboard keeps the flat list.
	card?: boolean
}

export const RequestsListWrapper = ({
	children,
	title,
	statusType,
	count,
	collapsible,
	collapsed,
	onToggle,
	card = false,
}: Props) => {
	const content = (
		<>
			<PortalSectionHeader
				statusType={
					statusType === "planned" || statusType === "paused"
						? "project"
						: "issue"
				}
				status={statusType}
				count={count}
				collapsible={collapsible}
				collapsed={collapsed}
				onToggle={onToggle}
				mutedIcon
				Icon={statusType === "inbox" ? MessageCircle : undefined}
				iconClassName={
					statusType === "inbox"
						? "h-4 w-4 text-gray-400 dark:text-gray-600"
						: undefined
				}
				// Keep the rounded card at all widths (no mobile full-bleed).
				className={
					card
						? portalGroupHeaderClass
						: "max-md:mx-0 max-md:rounded-lg max-md:border-0 max-md:px-3"
				}
				style={card ? portalGroupHeaderStyle : undefined}
			>
				{title}
			</PortalSectionHeader>
			{card ? (
				<PortalGroupCollapse
					collapsed={!!collapsed}
					className={portalGroupPanelClass}
				>
					{children}
				</PortalGroupCollapse>
			) : (
				!collapsed && (
					<div className="divide-y divide-gray-200 overflow-hidden dark:divide-gray-700/50">
						{children}
					</div>
				)
			)}
		</>
	)
	return card ? <div className={portalGroupCardClass}>{content}</div> : content
}
